<template>
  <div
    ref="target"
    :class="{
      'right-0': isOpened,
      'right-[-80%]': !isOpened,
      'mobile-menu fixed top-0 h-screen w-4/5 overflow-y-auto bg-www-color-neutral-medium-dark transition-all duration-500': true,
      'flex flex-col': true,
    }"
  >
    <!-- Close Menu Button -->
    <div
      :class="{
        'colse-menu flex items-center justify-end py-5 pl-10 pr-25px text-right': true,
      }"
    >
      <button
        type="button"
        aria-label="Close Menu"
        @click="isOpened = false"
      >
        <PtcIcon
          name="ptc-close-menu"
          :class="{
            'text-www-color-white': true,
          }"
        />
      </button>
    </div>

    <!-- EducationMenu Component -->
    <EducationMenu
      v-if="menus"
      v-bind="props"
    />
    <!-- Appear in mobile only -->
    <li
      :class="{
        'flex items-center gap-1 md:hidden': true,
      }"
    >
      <GeneralLink
        v-if="signinButton"
        v-bind="signinButton"
        :class="{
          'pl-50px text-13px font-bold uppercase leading-none text-www-color-white': true,
        }"
      />
      <img
        alt="Sign In Arrow"
        :src="signInArrowImageSrc"
        width="15"
      />
    </li>
    <div
      :class="{
        'mt-20 px-5': true,
      }"
    >
      <SmallPrimaryButton
        v-if="signupButton"
        v-bind="signupButton"
        :class="{
          'sign-up-mobile-button font-ptc-Rajdhani': true,
        }"
      />
    </div>
    <!-- Onshape Mobile App -->
    <div
      :class="{
        'mobile-app mx-auto mb-4 mt-auto flex flex-col text-10px font-normal leading-3 tracking-wider text-www-color-white': true,
      }"
    >
      <LanguageSelector />

      <div
        :class="{
          flex: true,
        }"
      >
        <p
          :class="{
            'mr-10px border-r border-www-color-neutral-medium pr-10px': true,
          }"
        >
          Download the Onshape Mobile App
        </p>
        <a
          href="https://apps.apple.com/us/app/onshape-3d-cad/id923421284"
          :class="{
            'text-www-color-primary-lighter': true,
          }"
          >IOS</a
        >
        <a
          href="https://play.google.com/store/apps/details?id=com.onshape.app&amp;hl=en_US&amp;gl=US"
          :class="{
            'pl-2 text-www-color-primary-lighter': true,
            'before:mr-2 before:h-10 before:w-10 before:content-[\'\']': true,
          }"
        >
          Android
        </a>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { EducationHeader } from '~/sanity/types';
import { onClickOutside } from '@vueuse/core';
import PtcIcon from '~/components/Atoms/PtcIcon/PtcIcon.vue';
import SmallPrimaryButton from '~/components/Molecules/HeaderComponents/SmallPrimaryButton.vue';
import LanguageSelector from '~/components/Molecules/UtitlityBarComponent/LanguageSelector.vue';
import EducationMenu from '~/components/Organisms/EducationHeader/EduMenu.vue';
import GeneralLink from '~/components/Molecules/HeaderComponents/GeneralLink.vue';
const props = defineProps<EducationHeader>();

const isOpened = defineModel<boolean>('isOpened', {
  required: true,
  default: false,
});
const target = ref(null);
onClickOutside(target, () => {
  isOpened.value = false;
});
const { $staticImages } = useNuxtApp();
const signInArrowImageSrc = $staticImages['sign-in-arrow'];
</script>
<style>
.sign-up-mobile-button a {
  font-size: 15px;
  font-weight: 700;
  line-height: 19px;
}
.sign-up-mobile-button img {
  display: none !important;
}
</style>
